import { createSlice } from "@reduxjs/toolkit";

const projectsSlice = createSlice({
    name: 'projects',
    initialState: [],
    reducers: {

        // PROJECT
        initProjects: (state, action) => {
            const allProjects = action.payload.allProjects
            return allProjects
        },
        addProject: (state, action) => {
            const project = action.payload.project
            state.push(project)
        },
        updateProjectSolde: (state, action) => {
            const projectId = action.payload.projectId
            const newSolde = action.payload.newSolde

            const index = state.findIndex(
                (project) => project.projectId === projectId
            )

            state[index].solde = newSolde;
        },
        updateProject: (state, action) => {
            const projectId = action.payload.projectId
            const title = action.payload.title
            const description = action.payload.description
            const solde = action.payload.solde

            const index = state.findIndex(
                (project) => project.projectId === projectId
            )

            state[index].title = title;
            state[index].description = description;
            state[index].solde = solde;
        },
        deleteProject: (state, action) => {
            const projectId = action.payload.projectId

            const index = state.findIndex(
                (project) => project.projectId === projectId
            )

            state.splice(index, 1)
        },
        deleteAllProject: (state, action) => {
            state = [];

            return state;
        },

        // SPLIT
        initSplit: (state, action) => {
            const allSplit = action.payload.allSplit;

            allSplit.map(split => {
                const projectIndex = state.findIndex(
                    (project) => project.projectId === split.projectId
                )

                if (projectIndex !== -1) {
                    state[projectIndex].splits.push(split)
                }
            })
        },
        addSplit: (state, action) => {
            const projectId = action.payload.projectId
            const split = action.payload.split

            const index = state.findIndex(
                (project) => project.projectId === projectId
            )

            state[index].splits.push(split)
        },
        updateSplitSolde: (state, action) => {

            const projectId = action.payload.projectId
            const splitId = action.payload.splitId
            const newSolde = action.payload.newSolde
            const newOperationsHistory = action.payload.newOperationsHistory

            const projectIndex = state.findIndex(
                (project) => project.projectId === projectId
            )

            if (projectIndex === -1) {
                return state
            }

            const splitIndex = state[projectIndex].splits.findIndex(
                (split) => split.splitId === splitId
            )

            if (projectIndex !== -1 && splitIndex !== -1) {
                state[projectIndex].splits[splitIndex].solde = newSolde;
                state[projectIndex].splits[splitIndex].operationsHistory = newOperationsHistory;
            } else {
                return state;
            }
        },
        deleteSplit: (state, action) => {
            const projectId = action.payload.projectId
            const splitId = action.payload.splitId

            const projectIndex = state.findIndex(
                (project) => project.projectId === projectId
            )

            if (projectIndex === -1) {
                return state
            }

            const splitIndex = state[projectIndex].splits.findIndex(
                (split) => split.splitId === splitId
            )

            if (projectIndex !== -1 && splitIndex !== -1) {
                state[projectIndex].splits.splice(splitIndex, 1)
            } else {
                return state;
            }
        },
        updateSplit: (state, action) => {
            const projectId = action.payload.projectId
            const splitId = action.payload.splitId

            const title = action.payload.title
            const description = action.payload.description
            const solde = action.payload.solde
            const target = action.payload.target
            const operationsHistory = action.payload.operationsHistory

            const projectIndex = state.findIndex(
                (project) => project.projectId === projectId
            )

            if (projectIndex === -1) {
                return state
            }

            const splitIndex = state[projectIndex].splits.findIndex(
                (split) => split.splitId === splitId
            )

            if (projectIndex !== -1 && splitIndex !== -1) {
                state[projectIndex].splits[splitIndex].title = title;
                state[projectIndex].splits[splitIndex].description = description;
                state[projectIndex].splits[splitIndex].solde = solde;
                state[projectIndex].splits[splitIndex].target = target;
                state[projectIndex].splits[splitIndex].operationsHistory = operationsHistory;
            } else {
                return state;
            }

        },
    }
})

// PROJECT
export const { initProjects } = projectsSlice.actions;
export const { addProject } = projectsSlice.actions;
export const { updateProjectSolde } = projectsSlice.actions;
export const { updateProject } = projectsSlice.actions;
export const { deleteProject } = projectsSlice.actions;
export const { deleteAllProject } = projectsSlice.actions;

// SPLIT
export const { initSplit } = projectsSlice.actions;
export const { addSplit } = projectsSlice.actions;
export const { updateSplitSolde } = projectsSlice.actions;
export const { deleteSplit } = projectsSlice.actions;
export const { updateSplit } = projectsSlice.actions;

export default projectsSlice.reducer;


